<template>
    <div class="modal fade" id="modalSearch" tabindex="-1" role="dialog" aria-labelledby="searchLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">                    
                    <h3>Search e-Receipts by email</h3>                
                    <button class="btn btn-lg btn-default float-end" type="button" data-bs-dismiss="modal"><i class="fas fa-lg fa-times" aria-hidden="true"></i></button>        
                </div>
                <div class="modal-body">
                    <div class="form-row">			
                        <div class="col input-group form-label-group">
                            <input type="text" class="form-control" v-model="search" placeholder="Enter an email address">
                            <label>Enter an email address</label>
							<button type="button" :disabled="search == ''" v-on:click="search = ''" class="btn btn-danger"><i class="fas fa-times"></i> Clear</button>						    
                        </div>			
                    </div>   
                </div>                                                        
                <div class="modal-footer">
                    <div class="float-end">                  
                        <button type="button" class="btn btn-primary me-2" :disabled="search == ''" v-on:click="doSearch()"><i class="fas fa-search"></i> Search</button>                
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><i class="fas fa-times"></i> Close</button>                
                    </div>
                </div> 
            </div>
        </div>
    </div>
</template>
<script>
import { Modal } from 'bootstrap';
export default {
    data() {
        return {
            search: '',	
            modal: null	    
        }
    },
    methods: {
        close: function() {
            this.modal.hide();            
        },      
        doSearch: function() {
            this.$router.push({ name: 'ereceipt', params: { type: 'email', param: this.search.toLowerCase() } });
            this.close();
        }
    },
    computed: {
                
    },
    mounted: function() {
        this.modal = new Modal(document.getElementById('modalSearch'));
    }
}
</script>
<style>
.modal-footer {
    display: block;
}
</style>